/**
 * Conditional logger that only logs in development/localhost environment
 */

const isDevelopment = () => {
	// Check if we're in development mode
	if (typeof window !== "undefined") {
		// Client-side: check hostname
		return (
			window.location.hostname === "localhost" ||
			window.location.hostname === "127.0.0.1" ||
			process.env.NODE_ENV === "development"
		);
	}
	// Server-side: check NODE_ENV
	return process.env.NODE_ENV === "development";
};

export const devLog = {
	log: (...args: unknown[]) => {
		if (isDevelopment()) {
			console.log(...args);
		}
	},
	error: (...args: unknown[]) => {
		if (isDevelopment()) {
			console.error(...args);
		}
	},
	warn: (...args: unknown[]) => {
		if (isDevelopment()) {
			console.warn(...args);
		}
	},
	info: (...args: unknown[]) => {
		if (isDevelopment()) {
			console.info(...args);
		}
	},
};

